import Vue from 'vue';
import Cleave from 'cleave.js';
import "cleave.js/dist/addons/cleave-phone.us";

Vue.directive('cleave', {
  bind(el, binding) {
    const input = el.querySelector('input');
    input._vCleave = new Cleave(input, binding.value);
  },
  unbind(el) {
    const input = el.querySelector('input');
    input._vCleave.destroy();
  }
});

Vue.directive('format', {
  bind(el, binding) {
    const masks = {
      phone: {
        phone: true,
        phoneRegionCode: 'US',
        delimiter: '-'
      },
      hours: {
        numeral: true,
        numeralDecimalScale: 1
      },
      number: {
        numeral: true,
        numeralThousandsGroupStyle: 'thousand',
      },
      money: {
        prefix: '$ ',
        numeral: true,
        numeralThousandsGroupStyle: 'thousand',
      },
      postcode: {
        blocks: [5],
        numericOnly: true
      },
      year: {
        numericOnly: true,
        blocks: [4]
      }
    };

    const input = el.querySelector('input');
    const mask = Object.keys(binding.modifiers)[0];
    const clientInput = input.cloneNode(false);
    const event = document.createEvent('Event');

    const updateValue = () => {
      let rawValue = clientInput._vCleave.getRawValue();
      let prefixLength = clientInput._vCleave.properties.prefixLength;

      if (prefixLength) {
        rawValue = rawValue.slice(prefixLength, rawValue.length);
      }

      input.value = rawValue;
      input.dispatchEvent(event);
    };

    event.initEvent('input', true, true);

    clientInput._vCleave = new Cleave(clientInput, masks[mask]);
    clientInput.addEventListener('input', updateValue);

    input.type = 'hidden';
    input.id = '';
    input.parentNode.insertBefore(clientInput, input.nextSibling);
  },
  update (el) {
    const input = el.querySelector('input');
    const clientInput = input.nextSibling;

    setTimeout(() => { clientInput._vCleave.setRawValue(input.value) }, 0);
  },
  unbind(el) {
    const clientInput = el.querySelector('input').nextSibling;
    clientInput._vCleave.destroy();
  }
});

Vue.directive('autofocus', {
  bind(el) {
    const input = el.querySelector("input:not([type = 'hidden'])");

    Vue.nextTick(() => {
      input.focus();
    },);
  }
});
